export const MuiFormControl = {
    styleOverrides: {
        root: {},
    },
};
export const MuiFormControlLabel = {
    styleOverrides: {
        label: {
            '&.Mui-disabled': {
                opacity: '.7',
            },
        },
    },
};
